import models from "modules/models";
import BaseRxApiService from "./baseRxApiService";

export default class CommunityRxApiService extends BaseRxApiService {
  constructor() {
    super(models.COMMUNITY);
  }
}
